"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGridItemHeight = void 0;

function getGridItemHeight(width) {
  return width * (9 / 16) + 125;
}

exports.getGridItemHeight = getGridItemHeight;